import PaymentMethodFormatter from 'card-payment-highlight-lib/customFormatters/PaymentMethodFormatter';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import CommercePaymentSecondaryPostfixContent from './CommercePaymentSecondaryPostfixContent';
import { jsx as _jsx } from "react/jsx-runtime";
const renderPaymentMethodFormatter = (objectId, propertyDefinition, properties) => {
  return /*#__PURE__*/_jsx(PaymentMethodFormatter, {
    objectId: objectId.toString(),
    paymentCreationMethod: getPropertyValueFromProperties(properties, 'hs_payment_creation_method'),
    paymentMethodType: getPropertyValueFromProperties(properties, 'hs_payment_method_type'),
    referenceNumber: getPropertyValueFromProperties(properties, 'hs_reference_number'),
    last4: getPropertyValueFromProperties(properties, 'hs_payment_method_last_4'),
    bankOrIssuer: getPropertyValueFromProperties(properties, 'hs_payment_method_bank_or_issuer')
    // @ts-expect-error Records uses GQL property definition structure. This is a
    // known property issue as they have not updated the type definitions. This roughly matches Property
    // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
    ,
    propertyDefinition: propertyDefinition
  });
};
const getPaymentChickletSecondaryDisplayLabels = ({
  properties,
  objectId,
  propertyDefinitions
}) => {
  const propertyFormatters = {
    hs_payment_method_type: propertyDefinition => renderPaymentMethodFormatter(objectId, propertyDefinition, properties)
  };
  return {
    copyDisabled: true,
    propertyFormatters,
    additionalPostfixContent: /*#__PURE__*/_jsx(CommercePaymentSecondaryPostfixContent, {
      objectId: objectId,
      properties: properties,
      propertyDefinitions: propertyDefinitions
    })
  };
};
export default getPaymentChickletSecondaryDisplayLabels;